import {
  FC,
  createContext,
  PropsWithChildren,
  useEffect,
  useMemo,
  useState,
} from "react";

import { useSdk, useLang } from "@app/shared/lib/hooks";
import { LoadingOverlay } from "@app/shared/ui";

import { Localization } from "./localization";
import { LocalizationStore } from "./localization-store";

export const LocContext = createContext<Localization>({} as Localization);

// TODO: refactor, use loc module from SDK
export const LocProvider: FC<PropsWithChildren> = ({ children }) => {
  const [ready, setReady] = useState(false);
  const sdk = useSdk();
  const locStore = useMemo(
    () => new LocalizationStore(sdk.api, () => setReady(true)),
    [sdk.api],
  );
  const loc = useMemo(() => new Localization(locStore), [locStore]);

  const { lang } = useLang();

  useEffect(() => {
    const targetLang = lang;
    if (!ready || locStore.lang !== targetLang) {
      setReady(false);

      (async () => {
        await locStore.init(targetLang);
        setReady(true);
      })();

      return;
    }

    setReady(true);
  }, [lang, ready, locStore]);

  if (!ready) return <LoadingOverlay position="absolute" />;

  return <LocContext.Provider value={loc}>{children}</LocContext.Provider>;
};
